module.exports = __webpack_public_path__ + "static/full-logo-noBG-x512-3c5f59610999fbea9625bda1238574ad.png";